import type {ReactAction} from '@netx/core/bootstrap';
import {faFilePdf} from '@fortawesome/pro-solid-svg-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {CategoryActionLabel} from '../locales';
import {categoryActionCreatePDFDownload} from './category-create-pdf-download';
import {categoryActionCreatePDFShareLink} from './category-create-pdf-share-link';

export const categoryActionCreatePDFIcon = faFilePdf;

/**
 * Create pdf from category assets
 * @param params
 * @returns Action
 */
export const categoryActionCreatePDF = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-create-pdf',
	cb: () => {}, //dispatcher.trigger(CATEGORY_EVENT.CREATE_PDF, category),
	//enableTest: () => canCreatePdfFromCategory(category),
	icon: categoryActionCreatePDFIcon,
	get label() {
		return CategoryActionLabel.CREATE_PDF;
	},
	children: [
		categoryActionCreatePDFDownload(category),
		categoryActionCreatePDFShareLink(category),
	],
	...params,
});

export default categoryActionCreatePDF;
